import { Loader2, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import type { ArtifactSummary } from "@/api/client";

type DeleteArtifactDialogProps = {
  artifact: ArtifactSummary | null;
  onClose: () => void;
  onDeleteConfirm: () => void;
  isPending: boolean;
};

export function DeleteArtifactDialog({
  artifact,
  onClose,
  onDeleteConfirm,
  isPending,
}: DeleteArtifactDialogProps) {
  return (
    <Dialog open={!!artifact} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Supprimer l'artefact</DialogTitle>
          <DialogDescription>
            Cette action est irréversible. L'artefact <span className="font-semibold text-[#0F172B]">«&nbsp;{artifact?.name}&nbsp;»</span> sera définitivement supprimé.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-9 items-center rounded-lg border border-[#E2E8F0] bg-white px-4 text-sm font-medium text-[#0F172B] transition-colors hover:bg-[#F8FAFC]"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onDeleteConfirm}
            disabled={isPending}
            className="inline-flex h-9 items-center gap-1.5 rounded-lg bg-red-500 px-4 text-sm font-medium text-white transition-colors hover:bg-red-600 disabled:opacity-60"
          >
            {isPending ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Trash2 className="h-3.5 w-3.5" />}
            Supprimer
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
